// extracted by mini-css-extract-plugin
module.exports = {"EledoLoader":"EledoLoader_EledoLoader__12JEe","scaling":"EledoLoader_scaling__3IBRE"};